<ng-container *ngIf="this.isNeedToShow && messages">
    <p class="text-base mt-4 font-medium text-blue-theme-color"><ng-container  *ngIf="!(this.statusData[3].status == 2 && this.formattedTime == '0:00')">{{this.formattedTime + ' | '}}</ng-container>{{messages}}</p>
    <div class="flex orderLiveStatus sm:-left-6 min-h-16 relative w-full xl:w-[650px] mt-5">    
        <ng-container *ngFor="let item of statusData; let i = index">
            <div class="w-1/4 px-2">
                <div class="w-full flex flex-col justify-center items-center">
                    <div class="w-[30px] h-[30px] bg-white-color overflow-hidden relative z-10 rounded-full p-0  border" [ngClass]="item.status != 2? 'border-[#CECECE]' : 'border-[#4BAE4F]'">
                        <img *ngIf="item.status == 2" draggable="false" class="w-full h-full " src="assets/images/ui/right_tic.png" alt=""> 
                        <p *ngIf="item.status != 2" class="text-center text-lg font-semibold text-blue-theme-color">{{i + 1}}</p>
                        <div class="absolute top-[-1px] left-[-1px] w-full z-20">
                            <mat-spinner *ngIf="item.status == 1" [diameter]="30" [color]="'#0B1640'"></mat-spinner>
                        </div>
                    </div>
                    <div class="text-center text-sm font-semibold mt-2 text-blue-theme-color">
                        {{item.title}}
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="absolute top-[14px] w-[73%] left-1/2 -translate-x-1/2">
            <mat-progress-bar mode="determinate" [value]="this.progressValue"></mat-progress-bar>
        </div>
    </div>
</ng-container>